
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMultiply as ObiMultiplyElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-multiply.js';
 
 
 

 
 export const ObiMultiply = createComponent({
   react: React,
   tagName: 'obi-multiply',
   elementClass: ObiMultiplyElement,
   events: {
     
   }
  });
 
 